import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
// import gsap from 'gsap'
// import {TweenMax, Power2, TimelineLite, TimelineMax, TweenLite} from "gsap/TweenMax"


import CustomHelmet from '../components/CustomHelmet'
import BackgroundVideo from '../components/BackgroundVideo'
import Button from '../components/Button'

import Testimonials from '../components/_Redesign/Testimonials'
import AdmissionsSignup from '../components/_Redesign/AdmissionsSignup'
import Signup from '../components/_Redesign/Signup'
import Fellows from '../components/_Redesign/Fellows'

import { TimelineMax, TweenMax, Linear } from 'gsap';

var ScrollMagic
if (typeof window === 'object') {
    ScrollMagic = require('scrollmagic')

    // import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
	// require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
}

class RedesignOverview extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mainVideoPlay: false
        }
    }
    componentDidMount() {
        this.controller = new ScrollMagic.Controller()

        this.setState({
            controller: this.controller
        })

        const timeline = this.refs.timeline
        if( timeline ) {
            const blocks = Array.from(timeline.getElementsByClassName('block'));
            const timelineIndicator = this.refs.timelineBar
            const TL = new TimelineMax()

            TL.to(timelineIndicator, 0.5, {height: timeline.clientHeight, ease: 'Linear'})

            const timelineScroll = new ScrollMagic.Scene({
                triggerElement: timeline,
                triggerHook: 0.5,
                duration: timeline.clientHeight*1.15,
            })
            // .setTween(TL)
            .addTo(this.controller)

            blocks.map( (b, index) => {
                const activateSections = new ScrollMagic.Scene({
                    triggerElement: b,
                    triggerHook: 0.5
                })
                .setClassToggle(b, 'show')
                .addTo(this.controller)
                // .addIndicators()
            })
        }

    }
	componentWillUnmount() {
        this.state.controller.destroy(true)
        this.controller.destroy(true)
	}

  render() {
    const { data: { page, fellows } } = this.props;
    const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;
    const pageData = this.props.pathContext.data

    // console.log('THE DATA == ', pageData);
    return (
        <div className="overview-template page-redesign">
            <div className="hero" style={{ background: `url(${pageData.heroImage.file.url}) center no-repeat`, backgroundSize: 'cover' }}>
                <div className="video-bg">
                {
                    pageData.heroMiniReel &&
                    <BackgroundVideo src={ pageData.heroMiniReel } playsInline loop muted autoPlay />
                }
                </div>
                <div className="content-wrapper">
                    <div className="content text-center">
                        <div>
                            <h1 className="h1 large" dangerouslySetInnerHTML={{ __html: pageData.headline }} />
                        </div>
                        {
                            pageData.heroFullReel &&
                            <Button text="Watch the video" onClick={ () => this.setState({ mainVideoPlay: true })} />
                        }
                    </div>
                </div>
                {
                    this.state.mainVideoPlay &&
                    <div className="fixed-video">
                        <video playsInline autoPlay controls="true">
                            <source src={ pageData.heroFullReel }/>
                        </video>
                        <div className="close" onClick={ () => this.setState({ mainVideoPlay: false })} />
                    </div>
                }
            </div>
            <section>
                <div className="block intro-spacing">
                    <h2 className="h2 no-transform" dangerouslySetInnerHTML={{ __html: pageData.introContent.introContent }} />
                </div>
            </section>
            <section>
                <div className="block block-split-link custom-grid-7-5">
                    <div className="item standard-spacing bg-grey">
                        <h3 className="h1 medium" dangerouslySetInnerHTML={{ __html: pageData.linkSectionHeadline }} />
                        <p dangerouslySetInnerHTML={{ __html: pageData.linkSectionContent.linkSectionContent }} />
                    </div>
                    <div className="item standard-spacing bg-black-light">
                        <div className="content-wrapper">
                            <div className="content">
                                <h3 style={{ marginBottom:'30px' }} className="no-transform color-white" dangerouslySetInnerHTML={{ __html: pageData.linkSectionSecondaryHeadline }} />
                                <Button text={ pageData.linkSectionLink.text} href={ pageData.linkSectionLink.link } />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="block block-list-custom-details standard-spacing grid-4 grid-tablet-2">
                    <div className="item">
                        <p className={`headline-with-accent ${pageData.interestFormColor.interestFormColor.toLowerCase()}`}><strong dangerouslySetInnerHTML={{ __html: pageData.accentHeadline1 }} /></p>
                        <p dangerouslySetInnerHTML={{ __html: pageData.accentContent1.accentContent1 }} />
                    </div>
                    <div className="item">
                        <p className={`headline-with-accent ${pageData.interestFormColor.interestFormColor.toLowerCase()}`}><strong dangerouslySetInnerHTML={{ __html: pageData.accentHeadline2 }} /></p>
                        <p dangerouslySetInnerHTML={{ __html: pageData.accentContent2.accentContent2 }} />
                    </div>
                    <div className="item">
                        <p className={`headline-with-accent ${pageData.interestFormColor.interestFormColor.toLowerCase()}`}><strong dangerouslySetInnerHTML={{ __html: pageData.accentHeadline3 }} /></p>
                        <p dangerouslySetInnerHTML={{ __html: pageData.accentContent3.accentContent3 }} />
                    </div>
                    <div className="item">
                        <p className={`headline-with-accent ${pageData.interestFormColor.interestFormColor.toLowerCase()}`}><strong dangerouslySetInnerHTML={{ __html: pageData.accentHeadline4 }} /></p>
                        <p dangerouslySetInnerHTML={{ __html: pageData.accentContent4.accentContent4 }} />
                    </div>
                </div>
                <div className="block block-strokes-with-headline">
                    <div className="item">
                        <img src={`/images/${pageData.interestFormColor.interestFormColor}-strokes-wide.png`} alt="Green stroke" className="redesign-strokes" />
                    </div>
                    <p className="h1 large standard-spacing">Why { pageData.headline }</p>
                </div>
                <div className="timeline-container" ref="timeline">
                    <div className="progress-indicator" ref="timelineBar"></div>
                    <div className="block bottom-spacer grid-2 grid-tablet-1 grid-gap-90">
                        <div className="item">
                            <div className="content-wrapper standard-spacing">
                                <div className="content" dangerouslySetInnerHTML={{ __html: pageData.whyBlockContent1.whyBlockContent1 }} />
                            </div>
                        </div>
                        <div className="item">
                            <img src={ pageData.whyBlockImage1.file.url } alt=""/>
                        </div>
                    </div>
                    <div className="block bottom-spacer grid-2 grid-tablet-1 grid-gap-90 tablet-reverse">
                        <div className="item">
                            <img src={ pageData.whyBlockImage2.file.url } alt=""/>
                        </div>
                        <div className="item">
                            <div className="content-wrapper standard-spacing">
                                <div className="content" dangerouslySetInnerHTML={{ __html: pageData.whyBlockContent2.whyBlockContent2 }} />
                            </div>
                        </div>
                    </div>
                    <div className="block bottom-spacer grid-2 grid-tablet-1 grid-gap-90">
                        <div className="item">
                            <div className="content-wrapper standard-spacing">
                                <div className="content" dangerouslySetInnerHTML={{ __html: pageData.whyBlockContent3.whyBlockContent3 }} />
                            </div>
                        </div>
                        <div className="item">
                            <img src={ pageData.whyBlockImage3.file.url } alt=""/>
                        </div>
                    </div>
                </div>
                <div className="block standard-spacing" style={{ maxWidth: '1200px' }} dangerouslySetInnerHTML={{ __html: pageData.fullWidthContentSection.fullWidthContentSection }} />
            </section>
            <section>
                <div className="block block-quote-story-link standard-spacing grid-2 grid-tablet-1">
                    <div className="item standard-spacing">
                        <img src={ pageData.storyLinkAuthor.file.url } className="headshot" alt=""/>
                        <p className="large"><strong dangerouslySetInnerHTML={{ __html: pageData.storyLinkHeadline }} /></p>
                        <p dangerouslySetInnerHTML={{ __html: pageData.storyLinkExcerpt.storyLinkExcerpt }} />
                        <a href={ pageData.storyLink.link } className="hoverlink">{ pageData.storyLink.text }</a>
                    </div>
                    <div className="item">
                        <img src={ pageData.storyLinkImage.file.url } alt=""/>
                    </div>
                    <img src={`/images/${pageData.interestFormColor.interestFormColor}-strokes-new.png`} alt="Blue stroke" className="redesign-strokes strokes-top-right-corner" style={{ zIndex: 1 }} />
                </div>
            </section>
            <Fellows
              title="Experience a day in the life of a Global Citizen Year Fellow"
              cards={pageData.fellowsCards}
              link={ pageData.storyArchiveLink }
            />
            <section style={{ zIndex: '50', position: 'relative' }} id="signup">
                <Signup
                  title={ page.admissionsRfiText ? page.admissionsRfiText : "Sign up for more!" }
                  location={ this.props.location }
                  color={ pageData.interestFormColor ? pageData.interestFormColor.interestFormColor : 'Black' }
                />
            </section>
        </div>
    )
  }
}

export default RedesignOverview

export const query = graphql`
  query RedesignOverviewPageQuery {
    fellows: contentfulFellowsParents {
  	  title
      link {
        text
        link
      }
      fellowsCards {
        storyPosition
        storyLocation
        quoteTitle
        attribution
        quoteText
        link
        articleImage {
          sizes(quality:100, maxWidth:400) {
                ...GatsbyContentfulSizes_withWebp
          }
          file {
            url
          }
          title
        }
      }
  	}
    page: contentfulHomePage {
      heroText
      heroTitle
      homeHeroSlides {
        photo {
            title
            sizes(quality:81, maxWidth:1800) {
                ...GatsbyContentfulSizes_withWebp
            }
        }
      }
      afterHeroTitle
      afterHeroText
      afterHeroItemOneTitle
      afterHeroItemOneText
      afterHeroItemTwoTitle
      afterHeroItemTwoText
      afterHeroItemThreeTitle
      afterHeroItemThreeText
      afterHeroLink {
        text
        link
      }
      issuesTitle
      issuesText
      issuesLink {
        text
        link
      }
      countryCards {
        title
        description
        backgroundImage {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        link
      }
      accessTitle
      accessText
		accessLogoList {
        file {
          url
          fileName
          contentType
        }
        title
      }
      testimonialsTitle
      testimonials {
        title
        quote
        featuredMedia {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        videoLink
        profileImage {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        link {
          text
          link
        }
      }
      alumniCards {
        title
        text {
          text
        }
      }
      alumniTitle
      alumniLink {
        text
        link
      }
      signupTitle
      seoData {
        pageTitle
        pageDescription {
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          openGraphDescription
        }
        openGraphImage {
          file {
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/redesign-overview.js